import { Controller } from "@hotwired/stimulus"

// L'AGRANDISSEMENT D'UNE IMAGE DE GALERIE : un clic sur une vignette ouvre l'image en grand par-dessus
// la page, où l'on passe de l'une à l'autre aux flèches, et d'où l'on sort par Échap, par le voile ou
// par le bouton de fermeture.
//
// C'est ce qui manquait à notre galerie : les vignettes y sont rognées au format du cadre, et sans
// agrandissement le visiteur ne voit jamais la photographie entière. Une galerie de spectacle sert
// précisément à montrer des images.
//
// AUCUNE DONNÉE N'EST INJECTÉE EN HTML : l'adresse, la description et la légende viennent des
// attributs de la vignette — rendus et échappés par le gabarit — et sont posés par l'API du document
// (`src`, `alt`, `textContent`). Repris du projet de référence, dont c'est aussi la règle.
export default class extends Controller {
  static targets = ["overlay", "image", "caption", "thumb"]

  connect() {
    this.currentIndex = 0
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    // La page pourrait rester bloquée au défilement si le bloc disparaît fenêtre ouverte — une
    // navigation Turbo, par exemple.
    document.removeEventListener("keydown", this.onKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    this.currentIndex = this.thumbTargets.indexOf(event.currentTarget)
    this.show(this.currentIndex)

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    // LA PAGE NE DÉFILE PLUS DERRIÈRE : sans cela, la molette fait glisser le contenu sous l'image
    // agrandie, et l'on revient à un autre endroit en fermant.
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.onKeydown)
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.onKeydown)
  }

  next() {
    this.show((this.currentIndex + 1) % this.thumbTargets.length)
  }

  previous() {
    this.show((this.currentIndex - 1 + this.thumbTargets.length) % this.thumbTargets.length)
  }

  // Ferme SEULEMENT si le clic tombe sur le voile lui-même : un clic sur l'image ou sur une flèche
  // fermerait sinon la fenêtre au moment où l'on veut s'en servir.
  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  show(index) {
    this.currentIndex = index
    const thumb = this.thumbTargets[index]

    // L'IMAGE ENTIÈRE, jamais la vignette rognée : c'est tout l'intérêt d'agrandir.
    this.imageTarget.src = thumb.dataset.fullUrl
    this.imageTarget.alt = thumb.dataset.alt || ""

    const caption = thumb.dataset.caption || ""
    this.captionTarget.textContent = caption
    this.captionTarget.classList.toggle("hidden", caption === "")
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
    else if (event.key === "ArrowRight") this.next()
    else if (event.key === "ArrowLeft") this.previous()
  }
}
